import React, { useEffect, useState } from 'react';

import { useParams, useSearchParams } from 'react-router-dom';

import axios from 'axios';

import FileViewer, { needsFillPreview } from '../components/FileViewer';

import './FilePublic.css';



const FilePublic = () => {

  const { slug } = useParams();

  const [searchParams] = useSearchParams();

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState('');

  const [requiresPassword, setRequiresPassword] = useState(false);

  const [password, setPassword] = useState(searchParams.get('password') || '');

  const [payload, setPayload] = useState(null);



  const fetchFile = async (pwd = '') => {

    setLoading(true);

    setError('');

    try {

      const params = pwd ? { password: pwd } : {};

      const response = await axios.get(`/api/files/share/${slug}/`, { params });

      setPayload(response.data);

      setRequiresPassword(false);

    } catch (err) {

      const data = err.response?.data || {};

      if (data.requires_password) {

        setRequiresPassword(true);

        setError('');

      } else {

        setError(data.error || 'Файл недоступен');

      }

      setPayload(null);

    } finally {

      setLoading(false);

    }

  };



  useEffect(() => {

    fetchFile(password);

  }, [slug]);



  const handlePasswordSubmit = (e) => {

    e.preventDefault();

    fetchFile(password);

  };



  if (loading) {

    return <div className="file-public-page"><div className="loading"><div className="spinner" /></div></div>;

  }



  if (requiresPassword) {

    return (

      <div className="file-public-page">

        <div className="file-public-card">

          <h1>Доступ к файлу</h1>

          <form onSubmit={handlePasswordSubmit}>

            <input

              type="password"

              className="form-input"

              placeholder="Пароль"

              value={password}

              onChange={(e) => setPassword(e.target.value)}

            />

            <button type="submit" className="btn btn-primary">Открыть</button>

          </form>

        </div>

      </div>

    );

  }



  if (error || !payload?.file) {

    return (

      <div className="file-public-page">

        <div className="file-public-card">

          <h1>Файл недоступен</h1>

          <p>{error || 'Ссылка недействительна или срок действия истёк.'}</p>

        </div>

      </div>

    );

  }



  const { file, download_url: downloadUrl, link } = payload;

  const viewerUrl = password

    ? `${downloadUrl}${downloadUrl.includes('?') ? '&' : '?'}password=${encodeURIComponent(password)}`

    : downloadUrl;

  const fillViewer = needsFillPreview(file);



  return (

    <div className={`file-public-page ${fillViewer ? 'file-public-page--viewer' : ''}`}>

      <div className={`file-public-card ${fillViewer ? 'file-public-card--viewer' : ''}`}>

        <div className="file-public-header">

          <div>

            <h1>{file.original_filename}</h1>

            <p>{file.file_category_display} · {file.file_size_display}</p>

            {file.description && <p className="file-public-description">{file.description}</p>}

            {link?.expires_at && (

              <p className="file-public-meta">Ссылка действует до {new Date(link.expires_at).toLocaleString('ru-RU')}</p>

            )}

          </div>

          <a href={`${viewerUrl}${viewerUrl.includes('?') ? '&' : '?'}download=1`} className="btn btn-primary">

            Скачать

          </a>

        </div>

        <div className="file-public-viewer">

          <FileViewer file={file} downloadUrl={viewerUrl} fill={fillViewer} />

        </div>

      </div>

    </div>

  );

};



export default FilePublic;

